module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-splitter"
    }
  }, [_c('v-ons-page', [_c('v-ons-toolbar', [_c('div', {
    staticClass: "left"
  }, [_c('v-ons-toolbar-button', {
    on: {
      "click": function () { return _vm.openSide = !_vm.openSide; }
    }
  }, [_c('v-ons-icon', {
    attrs: {
      "icon": "ion-navicon",
      "size": "28px",
      "fixed-width": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('v-ons-splitter', [_c('v-ons-splitter-side', {
    attrs: {
      "swipeable": "",
      "width": "150px",
      "collapse": "",
      "side": "left",
      "open": _vm.openSide
    },
    on: {
      "update": function($event) {
        _vm.openSide = $event
      }
    }
  }, [_c('v-ons-page', [_c('v-ons-toolbar', {
    attrs: {
      "modifier": "transparent"
    }
  }), _vm._v(" "), _c('v-ons-list', {
    staticClass: "menu-list"
  }, [_c('v-ons-list-item', {
    staticClass: "menu-main",
    attrs: {
      "tappable": ""
    },
    on: {
      "click": function($event) {
        _vm.openPage('home', 'Home')
      }
    }
  }, [_c('v-ons-icon', {
    attrs: {
      "icon": "fa-home"
    }
  }), _vm._v("\n              Home\n            ")], 1), _vm._v(" "), _c('v-ons-list-item', {
    staticClass: "menu-item",
    attrs: {
      "tappable": "",
      "modifier": "nodivider"
    },
    on: {
      "click": function($event) {
        _vm.openPage('news', 'News')
      }
    }
  }, [_c('v-ons-icon', {
    attrs: {
      "icon": "fa-plus"
    }
  }), _vm._v("\n              News\n            ")], 1), _vm._v(" "), _c('v-ons-list-item', {
    staticClass: "menu-item",
    attrs: {
      "tappable": "",
      "modifier": "nodivider"
    },
    on: {
      "click": function($event) {
        _vm.openPage('settings', 'Settings')
      }
    }
  }, [_c('v-ons-icon', {
    attrs: {
      "icon": "fa-bookmark"
    }
  }), _vm._v("\n              Settings\n            ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-ons-splitter-content', [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fd29058","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/splitterMain.vue
// module id = 21
// module chunks = 0